export default {
      id: "video-event_sign-violation-usage",
      viewBox: "0 0 25 22",
      url: __webpack_public_path__ + "img/icons.svg#video-event_sign-violation",
      toString: function () {
        return this.url;
      }
    }